<template>
    <div id="footer">
      <div class="container">
        <div class="row">
          <div class="col col-lg-12">
            <h2>Kontakt</h2>
          </div>
        </div>
        <div class="row">
          <div class="col col-12 col-lg-6">
            <h5 v-if="data.name != null"><i class="far fa-user-circle"></i><b> {{ data.name }}</b></h5>
            <ul>
                <li v-if="data.email != null"><i class="fas fa-at"></i> {{ data.email }}</li>
                <li v-if="data.phone_number != null"><i class="fas fa-phone"></i> {{ data.phone_number }}</li>
                <li v-if="data.address != null"><i class="fas fa-map-marker-alt"></i> {{ data.address }}</li>
                <li class="map" id="map1">
                    <google-map/>
                </li>
            </ul>
          </div>
          <div class="col col-12 col-lg-6" id="contact_us">
              <contact-form/>       
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="container">
          <div class="row">
            <div class="col col-lg-6">© Nad Chvojnickým Potokom 2020</div>
            <div class="col col-lg-6">
              <a class="author" href="mailto:tomaschovanec.biz@gmail.com" target="_blank" rel="noopener noreferrer">
                  Made by <span><b>Tomáš Chovanec</b></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import ContactForm from '@/components/ContactForm'
    import GoogleMap from '@/components/GoogleMap'
    import axios from 'axios';

    export default {
        data() {
            return {
                data: [],
                errors: []
            }
        },
        // Fetches posts when the component is created.
        created() {
            var authOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: 'http://www.clun-forest.sk/cockpit/api/singletons/get/cotact?token=715b9f9a9f192319672a7a842fc494',
                json: true
            };
            axios(authOptions)
            .then(response => {
                this.data = response.data;
                console.log(this.data);            
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        components: {
            ContactForm,
            GoogleMap
        }
    }
</script>

<style>
  #footer {
    padding: 40px 0 0;
    position: relative;
    text-align: left;
    color: #eaeaea;
    background: url("/static/Images/footer.jpg") no-repeat center fixed;
    background-size: cover;
  }
  #footer > .container .row:first-child .col {
    padding-bottom: 20px; 
    border-bottom: solid 1px #777;
  }
  #footer::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at bottom right, rgba(30,30,30,0.7), rgba(0,0,0,0.8));
  }
  #footer ul {
    padding: 10px 5px;
  }
  #footer ul li {
    padding: 5px;
    list-style-type: none;
  }
  #footer ul li.map {
    padding: 20px 5px;
    overflow: hidden;
  }
  #footer .container-fluid {
    background-color:  rgba(0,0,0,0.5);
    color: #aaa;
  }
  #footer .container-fluid .col:last-child a {
    float: right;
    color: #aaa;
  }
  #contact_us h5 {
    text-align: center
  }
  #footer .fas, #footer .far {
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue